const toggleMenuVisiblity = document.querySelector("[data-action='toggle-menu-visiblity']");

const header = document.querySelector("header");
    
const html = document.querySelector("html");

const menuLinks = document.querySelectorAll('[data-item="menu-link"]');

toggleMenuVisiblity.addEventListener("click", function () {
    let element = this;

    const active = element.closest(".active");
    if (window.innerWidth < 468) {
        if (active) {
            html.style.overflowY = 'auto';
        } else {
            html.style.overflowY = 'hidden';

        }
    }

    // Toggle class active for button
    element.classList.toggle("active");

    html.classList.toggle("show-menu");

    return false;
});

if (menuLinks.length > 0) {
    menuLinks.forEach((link) => {
        link.addEventListener("click", function () {
            toggleMenuVisiblity.click();
        });
    });
}

window.addEventListener('load', () => {


    
        if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
            if (header) {
                header.classList.add("fixed");
            }
    
        } else {
            if (header) {
                header.classList.remove("fixed");
            }
    
        }

});

window.addEventListener('scroll', function () {

        if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
            if (header) {
                header.classList.add("fixed");
            }

        } else {
            if (header) {
                header.classList.remove("fixed");
            }
        }

});


